/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const UPLOAD_LOGO_VIEWBOX_W = 21;
const UPLOAD_LOGO_VIEWBOX_H = 20;

const UPLOAD_LOGO_PATH =
  'M10.0582 0C8.49665 0.00112895 6.95708 0.367934 5.56279 1.07104C4.1685 1.77414 2.95825 2.79399 2.02896 4.04891C1.09968 5.30383 0.477196 6.75894 0.211374 8.29769C-0.0544476 9.83643 0.0437791 11.416 0.498186 12.91C0.492396 12.9431 0.492396 12.9769 0.498186 13.01C0.874953 14.2218 1.48281 15.3493 2.28819 16.33L0.288186 18.33C0.149429 18.4706 0.0554325 18.6492 0.0180584 18.8432C-0.0193158 19.0372 0.0016069 19.2379 0.0781863 19.42C0.163129 19.6049 0.302455 19.7595 0.477563 19.8631C0.652671 19.9668 0.855227 20.0145 1.05819 20H10.0582C12.1453 19.9985 14.1797 19.3439 15.8762 18.128C17.5726 16.9122 18.8461 15.196 19.5182 13.22V13.14C19.8667 12.1294 20.0491 11.069 20.0582 10C20.0582 8.68678 19.7995 7.38642 19.297 6.17317C18.7944 4.95991 18.0578 3.85752 17.1293 2.92893C16.2007 2.00035 15.0983 1.26375 13.885 0.761205C12.6718 0.258658 11.3714 0 10.0582 0ZM10.0582 18H3.46819L3.76819 17.71L12.1782 9.29C12.3651 9.10677 12.6164 9.00414 12.8782 9.00414C13.1399 9.00414 13.3913 9.10677 13.5782 9.29L17.1982 12.89L17.4282 13.11C16.8166 14.5594 15.7913 15.7964 14.4804 16.6661C13.1696 17.5359 11.6314 17.9999 10.0582 18ZM2.59819 12.87L4.17819 11.29C4.36555 11.1037 4.619 10.9992 4.88319 10.9992C5.14737 10.9992 5.40082 11.1037 5.58819 11.29L6.45819 12.16L3.73819 14.9C3.2571 14.2853 2.87267 13.6007 2.59819 12.87ZM18.0082 10.87L15.0082 7.87C14.4457 7.3082 13.6832 6.99264 12.8882 6.99264C12.0932 6.99264 11.3307 7.3082 10.7682 7.87L7.87819 10.76L6.99819 9.89C6.4361 9.33125 5.67574 9.01762 4.88319 9.01762C4.09063 9.01762 3.33027 9.33125 2.76819 9.89L2.05819 10.56C2.04822 10.3735 2.04822 10.1865 2.05819 10C2.05819 7.87827 2.90104 5.84344 4.40133 4.34315C5.90162 2.84285 7.93645 2 10.0582 2C12.1799 2 14.2148 2.84285 15.715 4.34315C17.2153 5.84344 18.0582 7.87827 18.0582 10C18.0731 10.2865 18.0731 10.5735 18.0582 10.86L18.0082 10.87Z';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Upload / image logo (21×20 viewBox). `size` sets rendered width; height scales to aspect ratio.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const UploadLogoIcon = ({
  size = 21,
  fill = 'currentColor',
  className = '',
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const { style: propsStyle, ...restProps } = props;
  const width = size;
  const height = (size * UPLOAD_LOGO_VIEWBOX_H) / UPLOAD_LOGO_VIEWBOX_W;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${UPLOAD_LOGO_VIEWBOX_W} ${UPLOAD_LOGO_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      overflow="visible"
      style={{ display: 'block', ...propsStyle, ...style }}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...restProps}
    >
      <path d={UPLOAD_LOGO_PATH} fill={fill} />
    </svg>
  );
};

UploadLogoIcon.propTypes = {
  ...iconPropTypes,
  fill: PropTypes.string,
  style: PropTypes.shape({}),
};

export { UploadLogoIcon };
export default UploadLogoIcon;
